import { ReactNode } from 'react';
import { View } from 'react-native';
import { Label } from '@/common/components/Label/Label';
import { IDataAttributes } from '@/common/types/general';
import { styles } from './Badge.styles';

export interface IBadgeProps extends IDataAttributes {
  children: ReactNode;
  size?: 'md' | 'lg';
  status: 'info' | 'warning' | 'error' | 'success' | 'disabled';
  emphasis?: 'soft' | 'normal';
  className?: string;
}

export const Badge = ({
  size = 'md',
  status,
  emphasis = 'normal',
  className,
  children,
  ...dataProps
}: IBadgeProps) => {
  return (
    <View
      className={styles.root({ status, emphasis, size, className })}
      {...dataProps}
    >
      <Label className={styles.label({ status, emphasis, size })} bold>
        {children}
      </Label>
    </View>
  );
};
